import { useAtomValue, useSetAtom } from "jotai";
import { CheckIcon } from "@/icons/widget-menu";
import { widgetMenuOptionsAtom, widgetMenuOptionsByNameAtom } from "@/interface/AppStore";
import type { MenuOptionResult, SetActiveSubMenu } from "../../types";
import styles from "../../WidgetMenu.module.css";
import { applyValue } from "../applyValue";
import { setNewOptions } from "../setNewOptions";

interface UseCheckButtonProps {
    setActiveSubMenu: SetActiveSubMenu;
}

export function useCheckButton({ setActiveSubMenu }: UseCheckButtonProps): MenuOptionResult {
    const options = useAtomValue(widgetMenuOptionsByNameAtom("check"));
    const setWidgetMenuOptions = useSetAtom(widgetMenuOptionsAtom);

    const uniqueValues = [...new Set(options.map((option) => option.value))];
    const checked = uniqueValues.length === 1 && (uniqueValues[0] as boolean);

    const handleClick = () => {
        setActiveSubMenu(null);

        const setCheckOptions = setNewOptions({ name: "check", setWidgetMenuOptions });

        applyValue({ options, value: !checked, setNewOptions: setCheckOptions });
    };

    const tippyContent = checked ? "Снять отметку о выполнении" : "Отметить как выполненное";

    return {
        content: <CheckIcon className={checked ? styles.svgStrokeActive : ""} />,
        handleClick,
        isActive: checked,
        tippyContent,
    };
}
